export default __webpack_public_path__ + "static/media/add_location-24px.fd3df92d.svg";